import { useState } from "react";

const FORM_URL = "https://readdy.ai/api/form/dagngfptto0ceqqni10g";

export default function Subscribe() {
  const [status, setStatus] = useState<{ type: "idle" | "ok" | "err"; msg: string }>({ type: "idle", msg: "" });
  const [sending, setSending] = useState(false);

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);

    const honeypot = (fd.get("phone_alt") as string) || "";
    if (honeypot.trim()) {
      setStatus({ type: "ok", msg: "订阅成功，坐等开瓜！" });
      form.reset();
      return;
    }

    const email = (fd.get("email") as string) || "";
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setStatus({ type: "err", msg: "请输入正确的邮箱地址。" });
      return;
    }

    setSending(true);
    setStatus({ type: "idle", msg: "" });
    try {
      const payload = new URLSearchParams();
      payload.set("email", email);
      const resp = await fetch(FORM_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: payload.toString(),
      });
      const text = await resp.text();
      let parsed: any = null;
      try {
        parsed = JSON.parse(text);
      } catch {
        parsed = null;
      }
      const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || "";
      if (resp.ok && parsed?.code === "OK") {
        setStatus({ type: "ok", msg: "订阅成功！新瓜反转第一时间推送给你。" });
        form.reset();
      } else if (String(serverMsg).toLowerCase().includes("spam")) {
        setStatus({ type: "err", msg: serverMsg || "提交未成功，请稍后再试。" });
      } else {
        setStatus({ type: "err", msg: serverMsg || "提交失败，请稍后再试。" });
      }
    } catch {
      setStatus({ type: "err", msg: "网络异常，请稍后再试。" });
    } finally {
      setSending(false);
    }
  }

  return (
    <section id="subscribe" className="relative overflow-hidden border-t border-background-200">
      <div className="absolute inset-0 bg-gradient-to-br from-primary-500 via-primary-400 to-accent-500"></div>
      <div className="pointer-events-none absolute -right-8 -top-8 h-40 w-40 rounded-full bg-background-50/10"></div>
      <div className="pointer-events-none absolute -bottom-10 left-10 h-52 w-52 rounded-full bg-background-50/10"></div>

      <div className="relative mx-auto max-w-7xl px-4 md:px-6 py-16">
        <div className="grid items-center gap-8 lg:grid-cols-2">
          <div>
            <h2 className="heading-font text-3xl leading-tight text-background-50 md:text-4xl">
              瓜田上新不迷路，蹲后续快人一步
            </h2>
            <p className="mt-4 max-w-lg text-sm leading-7 text-background-50/90 md:text-base">
              订阅每日看瓜追更动态，在新瓜上架、神反转出炉时第一时间收到提醒。看热闹这件事，
              交给我们帮你盯紧。
            </p>
          </div>

          <div className="rounded-xl bg-background-50/95 p-6 md:p-7">
            <h3 className="flex items-center gap-2 text-base font-bold text-foreground-950">
              <i className="ri-mail-send-line text-primary-500"></i>
              留下邮箱，准时开瓜
            </h3>
            <form onSubmit={handleSubmit} data-readdy-form className="mt-4">
              <div className="flex flex-col gap-3 sm:flex-row">
                <input
                  type="email"
                  name="email"
                  required
                  placeholder="你的邮箱地址"
                  className="w-full rounded-md border border-background-300 bg-background-50 px-3.5 py-3 text-sm text-foreground-900 outline-none transition focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
                />
                <button
                  type="submit"
                  disabled={sending}
                  className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 disabled:opacity-60"
                >
                  {sending ? "发送中…" : "立即订阅"}
                </button>
              </div>
              <div className="hp-trap" aria-hidden="true">
                <input
                  type="text"
                  name="phone_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  readOnly
                  aria-hidden="true"
                />
              </div>
              {status.msg && (
                <p
                  className={`mt-3 text-xs ${
                    status.type === "ok" ? "text-accent-700" : "text-primary-700"
                  }`}
                >
                  {status.msg}
                </p>
              )}
              <p className="mt-3 text-[11px] text-foreground-500">
                订阅即表示同意接收每日追更动态，可随时退订。
              </p>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}